
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate-terms",
      function () {
        return require("private-next-pages/candidate-terms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate-terms"])
      });
    }
  